import bee from "./Bee";
export default {
    name: "NewsLetterSubscriptions",
    /*
        var query = {
            [is_admin: true]
        }
    */
    /* eslint-disable no-unused-vars */
    get_news_letter_subscriptions(query, success, fail) {
        var req = {
            news_letter_subscriptions: {
                _desc: ["id"]
            }
        };

        bee.get(req).then(res => {
            if (success) {
                success(res.news_letter_subscriptions);
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
    /*
        var query = {
            id:4,
            is_admin: true,
            is_edit: true
        }
    */
    /* eslint-disable no-unused-vars */
    get_news_letter_subscription(query, success, fail) {
        // console.log(query);
        var q = {
            news_letter_subscription: {
                _w: [
                    ["id", "e", query.id]
                ]
            }
        };
        bee.get(q).then(res => {
            if (success) {
                success(res.news_letter_subscription);
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
    /*
        var query = {
            id: 0
        }
    */
    /* eslint-disable no-unused-vars */
    update_news_letter_subscription(query, success, fail) {
        var to_post = {
            news_letter_subscription: {
                ...query,
                _w: [
                    ["id", "e", query.id]
                ]
            }
        }
        delete to_post.news_letter_subscription.id;
        bee.update(to_post)
            .then(res => {
                success(res);
            }).catch(errors => {
                fail(errors);
            });
    },
}